<template>
  <div style="border: 0px solid black; width:100%;">
      <div class="welcome" style="border: 0px solid red;">
        <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
                <div class="box box-info">
                <div class="box-header with-border">
                    <div class="col-md-12">
                        <div class="col-md-4">
                            <h3 class="box-title">Thống Kê Số Lượng Có Ăn Sáng</h3>
                        </div>
                        <div class="col-md-8">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <!-- Date range -->
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <div class="form-group">
                                        <label>{{$t('service_history.date_from')}}</label>
                                        <date-picker
                                            @dp-change="changeDateTime($event)"
                                            class="form-control"
                                            v-model="start_datetime"
                                            :config="options"
                                        ></date-picker>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <div class="form-group">
                                        <label>{{$t('service_history.date_to')}}</label>
                                        <date-picker
                                            @dp-change="changeDateTime($event)"
                                            class="form-control"
                                            v-model="end_datetime"
                                            :config="options"
                                        ></date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-body">
                    <div class="chart">
                        <lte-chart
                            :chartConfig='totalVisitChartConfig'
                        >
                        </lte-chart>
                    </div>
                </div>
                </div>
        </row>
      </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import LTEChart from '@/components/LTEChart'
import utils from '@/lib/utils';

export default {
  name: "LeaseBackStatisticsOfBreakfastResidentClients",
  data() {
    return {
        end_datetime: '',
        start_datetime: '',
        options: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
        },
        totalVisitChartConfig: {
            type: 'bar',
            data: {
                labels: [],
                datasets: []
            },
            options: {
                onClick: this.onLick,
                responsive: true,
                pointDot: true,
                pointDotRadius: 4,
                pointDotStrokeWidth: 1,
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        usePointStyle: true
                    }
                },
                animation: {
                    duration: 0.5,
                    onComplete: function () {
                        var chartInstance = this.chart,
                        ctx = chartInstance.ctx;
                        ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'top';
                        this.data.datasets.forEach(function (dataset, i) {
                            ctx.fillStyle='#333333'
                            var meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                var data = dataset.data[index];
                                if (data > 0) {
                                    ctx.fillText(data, bar._model.x, bar._model.y + 10);
                                }                            
                            });
                        });
                    }
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: false,
                        },
                        ticks: {
                            autoSkip: true
                        },
                    }],
                    yAxes: [{
                        ticks: {           
                            beginAtZero: true,
                        },
                        stacked: true,
                        scaleLabel: {
                            display: false,
                        }
                    }]
                }
            }
        },
        dateArray: [],
        countApartmentBooking: [],
        countApartmentBookingClient: []
    };
  },
  watch: {
      STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS_DATA: function() {
            let data = this.STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS_DATA
            this.dateArray = []
            this.countApartmentBooking = []
            this.countApartmentBookingClient = []
            for (let i = 0, size = data.length; i < size; i++) {
                this.dateArray.push(data[i].date)
                this.countApartmentBooking.push(data[i].count_apartment_booking)
                this.countApartmentBookingClient.push(data[i].count_apartment_booking_client)
            }
            this.setTotalVisitChartDate()
        }
    },
  computed: {
    ...mapGetters([
        "STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS_DATA"
    ])
  },
  methods: {
    ...mapActions([
        "STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS"
    ]),
    statistictsHasBreakfastResidentClients: function(dateArray, start_datetime, end_datetime) {
        let filter = {
            params: {
                dateList: dateArray,
                from: start_datetime,
                to: end_datetime
            }
        }
        this.STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS(filter)
    },
    onLick: function (event, array) {
        event.preventDefault();
        let self = this
        if (array.length != 0) {
            var datasetLabel = array[0]['_model'].datasetLabel
            var label = array[0]['_model'].label
            self.$router.push({
                name: "LeaseBackResidentClientList",
                params: {
                    fromLeaseBackStatisticsOfBreakfastResidentClients: true,
                    datasetLabel: datasetLabel,
                    label: label
                }
            });
        } else {
            // console.log("You selected the background!");            
        }  
    },
    changeDateTime: function(event) {
        event.preventDefault();
        let dateArray = []
        dateArray = utils.getDaysBetweenTwoDate(this.start_datetime, this.end_datetime, 'DD/MM/YYYY')
        this.statistictsHasBreakfastResidentClients(dateArray, this.start_datetime, this.end_datetime)
    },
    setTotalVisitChartDate: function() {
        let labels, datasets
        labels = this.dateArray
        datasets = [
            {
                label: 'Số Lượng Booking',
                fill: false,
                backgroundColor: '#bfbf00',
                borderColor: '#bfbf00',
                data: this.countApartmentBooking
            },
            {
                label: 'Số Lượng Người Ở Có Ăn Sáng',
                fill: false,
                backgroundColor: '#ffff56',
                borderColor: '#ffff56',
                data: this.countApartmentBookingClient
            }
        ]
        let data = Object.assign({}, this.totalVisitChartConfig)
        data.data.labels = labels
        data.data.datasets = datasets
        this.totalVisitChartConfig = data
    }
  },
  mounted() {
        this.start_datetime = new Date()
        this.end_datetime = new Date()
        this.end_datetime.setDate(this.end_datetime.getDate() + 7)
        let dateArray = utils.getDaysBetweenTwoDate(this.start_datetime, this.end_datetime, 'DD/MM/YYYY')
        this.statistictsHasBreakfastResidentClients(dateArray, this.start_datetime, this.end_datetime)
  },
  components: {
    "date-picker": datePicker,
    'lte-chart': LTEChart,
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackStatisticsOfBreakfastResidentClients.vue